import React, { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { get } from '../../../../util/AcessoApi'
import { ordenarArrayObj } from '../../../../util/FuncoesComuns'
import { visualizar } from '../../../../util/AcessoApi'

const VisualizacaoUsuarioApp = (props) => {
    let { id } = useParams();
    const [dados, setDados] = useState({})


    useEffect(() => {
        if (id) {
            visualizar(`/estoque/produto`, id, obj => {
                setDados(obj)
            })
        }
    }, [id])

    const data = dados.id ? {
        titulo: 'Visualização de Produto',
        grupos: [
            {
                titulo: 'Dados Gerais',
                colunas: [
                    {
                        titulo: 'Código',
                        descricao: dados.id,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Código de Barras',
                        descricao: dados.codigo_barras,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Descrição',
                        descricao: dados.descricao,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Tipo Produto',
                        descricao: dados.produto_tipo.label,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Unidade de Medida',
                        descricao: dados.produto_unidade_medida ? dados.produto_unidade_medida.label : '',
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Peso',
                        descricao: dados.peso,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Tamanho',
                        descricao: dados.tamanho,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Unidades',
                        descricao: dados.unidades,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Saldo',
                        descricao: dados.quantidade || 0,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Cor',
                        descricao: dados.produto_cor ? dados.produto_cor.label : '',
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Estoque Mínimo',
                        descricao: dados.estoque_min,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Estoque Máximo',
                        descricao: dados.estoque_max,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Bloqueado',
                        descricao: dados.bloqueado.label,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Observação',
                        descricao: dados.observação,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Data Registro',
                        descricao: dados.data_registro,
                        tamanho: 'col-lg-6'
                    }
                ]
            }
        ]
    } : { titulo: 'Visualização de Produto' }

    return (
        <VisualizacaoPadrao data={data} id={id} {...props} />
    )
}

export default VisualizacaoUsuarioApp